// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bYqKZVKC9D7_Mv {
  position: relative;
  height: 50dvh;
  min-height: 450px;
  max-height: 480px;
  overflow: hidden;
  border-radius: 28px;
  box-shadow: 0px 8px 12px #091e4226, 0px 0px 1px #091e424f;
  color: #ffffff;
  text-align: left;
}
.bYqKZVKC9D7_Mv h1 {
  padding-top: 42px;
  padding-right: 8px;
  padding-left: 24px;
}
.bYqKZVKC9D7_Mv p {
  padding-right: 8px;
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;
}
.bYqKZVKC9D7_Mv img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 90%;
}
.wjMlN45WR7N3MP {
  background-color: #82b536;
}
.w8uYOavWKAG9aQ {
  background-color: #ffa900;
}
.lYC95w_ShqKE84 {
  background-color: #bf63f3;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `bYqKZVKC9D7_Mv`,
	"inboxCard": `wjMlN45WR7N3MP`,
	"plannerCard": `w8uYOavWKAG9aQ`,
	"boardCard": `lYC95w_ShqKE84`
};
export default ___CSS_LOADER_EXPORT___;
